import { ConditionType, type MappingRule } from '../types'

export const DEFAULT_TARGET_COLUMNS = [
  'CompanyEmployeeId',
  'FirstName',
  'LastName',
  'Gender',
  'Relationship',
  'MarriageStatus',
  'DateOfBirth',
  'Smoker',
  'SSN',
  'StreetAddress',
  'StreetAddressExt',
  'City',
  'StateProvince',
  'PostalCode',
  'County',
  'EmailAddress',
  'EmailAddressType',
  'PhoneNumber',
  'PhoneType',
  'EmploymentStatus',
  'IsExempt',
  'HireDate',
  'JobTitle',
  'Salary',
  'PayrollCycle',
  'Department',
]

export function buildDefaultRules(sourceColumns: string[]): MappingRule[] {
  const sourceColsLower = sourceColumns.map((c) => c.toLowerCase())

  return DEFAULT_TARGET_COLUMNS.map((target) => {
    const matchIdx = sourceColsLower.findIndex(
      (sc) => sc === target.toLowerCase()
    )
    return {
      id: `rule-${target}-${Date.now()}`,
      target,
      condition: ConditionType.DIRECT_MAPPING,
      source: matchIdx >= 0 ? sourceColumns[matchIdx] : '',
      normalize: [],
    }
  })
}
